export default __webpack_public_path__ + "images/wbtc_e6e5e6.svg";